<template>
	<div>
	<div class="alert-item" v-show="play">
		<div>
		<h1 hidden=false>{{siteId}}--{{siteIdF}}</h1> </div>
		<el-card class="box-cardRl">
			<div style="margin-bottom: 10px;text-align: center;">{{time}}</div>
			<span v-for="(child,index) in realData" :key="index" v-if="index%6==0">
		
			 <el-row >
				 <el-col :span="4">
					 <el-card class="pCardRl">
						 <span v-for="(v,key) in child" :key="key">
							 <div>{{key}}</div>
							 <div class="divValue" v-if="dataO[key]==0">{{v}}</div>
							 <div class="divValue" style="color: red;"
							 v-if="dataO[key]==1">{{v}}</div>
							 <div class="divStatus">{{dataStatus[key+"状态"]}}</div>
						 </span>					 
					 </el-card>
				 </el-col>
				 <el-col :span="4" v-if="index+1<realData.length">
					 <el-card class="pCardRl">
						<span v-for="(v,key) in realData[index+1]" :key="key" v-if="index+1<realData.length">
							 <div>{{key}}</div>
							 <div class="divValue" v-if="dataO[key]==0">{{v}}</div>
							 <div class="divValue" style="color: red;"
							 v-if="dataO[key]==1">{{v}}</div>
							 <div class="divStatus">{{dataStatus[key+"状态"]}}</div>
						 </span>
					  </el-card>
				 </el-col>
				 <el-col :span="4" v-if="index+2<realData.length">
					 <el-card class="pCardRl">
						 <span v-for="(v,key) in realData[index+2]" :key="key" v-if="index+2<realData.length">
							 <div>{{key}}</div>
							 <div class="divValue" v-if="dataO[key]==0">{{v}}</div>
							 <div class="divValue" style="color: red;"
							 v-if="dataO[key]==1">{{v}}</div>
							 <div class="divStatus">{{dataStatus[key+"状态"]}}</div>
						 </span>
						
					 </el-card>
				 </el-col>
				 <el-col :span="4" v-if="index+3<realData.length">
						 <el-card class="pCardRl">
							 <span v-for="(v,key) in realData[index+3]" :key="key" v-if="index+3<realData.length">
								 <div>{{key}}</div>
								 <div class="divValue" v-if="dataO[key]==0">{{v}}</div>
								 <div class="divValue" style="color: red;"
								 v-if="dataO[key]==1">{{v}}</div>
								 <div class="divStatus">{{dataStatus[key+"状态"]}}</div>
							 </span>
							
						 </el-card>
				 </el-col>
				 <el-col :span="4" v-if="index+4<realData.length">
						 <el-card class="pCardRl">
							 <span v-for="(v,key) in realData[index+4]" :key="key" v-if="index+4<realData.length">
								 <div>{{key}}</div>
								 <div class="divValue" v-if="dataO[key]==0">{{v}}</div>
								 <div class="divValue" style="color: red;"
								 v-if="dataO[key]==1">{{v}}</div>
								 <div class="divStatus">{{dataStatus[key+"状态"]}}</div>
							 </span>
							
						 </el-card>
				 </el-col>
				 <el-col :span="4" v-if="index+5<realData.length">
						 <el-card class="pCardRl">
							 <span v-for="(v,key) in realData[index+5]" :key="key" v-if="index+5<realData.length">
								 <div>{{key}}</div>
								 <div class="divValue" v-if="dataO[key]==0">{{v}}</div>
								 <div class="divValue" style="color: red;"
								 v-if="dataO[key]==1">{{v}}</div>
								 <div class="divStatus">{{dataStatus[key+"状态"]}}</div>
							 </span>
							
						 </el-card>
				 </el-col>
			 </el-row>
			</span>
		  <!-- <div v-for="(child,index) in realData" :key="index" class="text item">
		    {{ child }}
			<hr style="color: #87CEFA;">
		  </div> -->
		</el-card>
	</div>	
		
		
		<!-- <el-main  >	
			
			<div class="block" style="height:400px;width: 400px;">
				<div>{{time}}</div>
				<div style="height:100%;width:100%" >
					<el-row :gutter="5" type="flex" class="row-bg" justify="left" v-for="(child,index) in sliceList(realData,3) " :key="index">
						<el-col :span="8" v-for="(item,i) in child" :key="i" >
							<div class="grid-a-contentWidth">
								<div v-for="(v,j) in item" :key="j">
									<div>{{j}}</div>
									<div>{{v}}</div>
								</div>
								
							</div>
						</el-col >							
					</el-row>		
				</div>
			</div>
		</el-main> -->
	</div>
</template>

<script>
	import {timerSite} from '../../utils/sites.js'
	export default {
		name: "DataRl",
		//props:["siteId"],
		data() {
			return{
				siteId:0,//this.siteIdF.set()
				realData: [],
				timeId:'',
				time:'',
				dataO:{},
				dataStatus:{},
				param:{id:109},
				play:false

			}
		},
		beforeDestroy() {
			//debugger
			clearTimeout(this.timeId);
		},
		mounted() {
			//debugger
			//this.updata(this.$store.state.siteId);
		},
	   computed:{
			
			siteIdF: {			
				get:function(){
					//debugger
					//console.log("hachlog:"+this.$store.state.siteId);
					//this.$data.siteId=this.$store.state.siteId;
					this.updata(this.$store.state.siteId);
					
					return this.$store.state.siteId;
				},
				set:function(){
					//debugger
					this.$data.siteId=this.$store.state.siteId;
					//this.msg = value; //最后修改了msg    
				}
			 },
			sliceList() {
			    return function (data,count) {
			      if (data != undefined) {
			        let index = 0;
			        let arrTemp = [];
			        for (let i = 0; i < Object.keys(data).length; i++) {
			          index = parseInt(i / count);
			          if (arrTemp.length <= index) {
			            arrTemp.push([]);
			          }
			          arrTemp[index].push(data[i])
			        }
			        return arrTemp
			      }
			    }
			  }
	
				
		},
		
		// watch:{
		// 	siteId(val, newval){
		// 		debugger
		// 	}
		// },
		methods:{
			initEmps(){
				//var parm = new FormData()
				//parm.append('id', 'test')
				//debugger
				//parm.siteId=this.$data.siteId;
				
				
				clearTimeout(this.timeId);
				 var para="?siteId="+this.$data.siteId;
				 if(this.$data.siteId!=null){
					 this.getRequest('/data/real/realData'+para).then(resp => {
					 	/*  */
					 	/* var data=JSON.stringify(resp); */
					 	var m=0;
					 	var data1=new Array();
					 	var time;
					 	if(resp==undefined){
					 		
					 	}
					 	else if(resp.error){
					 		this.$data.time=null;
					 		this.$data.realData=null;
					 		this.$data.play=false
					 		this.$message({
					 		  type:'info',//info
					 		  message: resp.error
					 		});
					 	}
					 	else{
					 		for(var k in resp.data.fields){
					 			let mp={};
					 			let key=resp.data.fields[k].mingCh;
					 			mp[key]=resp.data.data[key];
					 			data1[m]=mp;
					 			m++;
					 		}
					 		time=resp.data.data["time"];
					 		// for( var k in resp.data.data ){//遍历packJson 对象的每个key/value对,k为key
					 		// 	if(k=="time")
					 		// 	time=resp.data.data[k];
					 		// 	else{
					 		// 		//for(var ky in resp[k])
					 		// 		//data1[m]=ky+':\u3000'+resp[k][ky];
					 		// 		let mp={};
					 		// 		mp[k]=resp.data.data[k];
					 		// 		data1[m]=mp;
					 		// 		m++;
					 		// 	}
					 		// }
					 		//data1[m]=data1[m]='时间:\u3000'+time;
					 		this.$data.time=time;
					 		this.$data.play=true;
					 		//delete resp.data.data.time
					 		this.$data.realData=data1;
					 		this.$data.dataO=resp.data.dataO
					 		if(resp.dataStatus!=null)
					 		this.$data.dataStatus=resp.dataStatus.data[0];
					 		else
					 		this.$data.dataStatus={};
					 		 //this.$data.realData=resp;
					 		 console.log(this.$data.realData); 
					 	}
					 	//debugger
					 	
					 	 this.timeId=this.Timer();
						 
						 if(sessionStorage.getItem('timeId')=="null")
						sessionStorage.setItem("timeId" ,timerSite(this.$store));
					     /* if (resp) {
					         this.nations = resp;
					         window.sessionStorage.setItem("nations", JSON.stringify(resp));
					     } */
					 })
				 }
				
			},
			updata(id){
				if(this.$data.siteId!=id){
					this.$data.siteId=id;
					this.initEmps();
				}
			
				
				
			},
			Timer(){
				return setTimeout(()=>{
						 //debugger
				          this.initEmps();
				        },60000)
			}
		}
	}
</script>

<style>
	.box-cardRl {
		text-align: left;
		width: 1200px;
		margin-top: 1px;
		margin-left: 5px;
		margin-right: 5px;
		font-family: 微软雅黑;
		color: #87CEFA;
		height: 100%;
	}
	.text {
	font-size: 18px;
	}
	
	.item {
	padding: 5px 0;
	}
	
	
	/* .box-cardRl{
	
	width: 400px;
	
	margin: 20px auto;
	
	} */
	
	.block{
	
	padding: 10px 10px;
	outline-color: #55ffff;
	outline-width: inherit;
	outline-style: auto;
	background-color: rgb(255, 255, 255);
	
	}
	
	.alert-item{
	
	margin-bottom: 10px;
	float: left;
	padding-top: 0px;
	}
	
	.tag-item{
	
	margin-right: 15px;
	
	}
	
	.link-title{
	
	margin-left:35px;
	
	}
	
	.components-container {
	
	position: relative;
	
	height: 100vh;
	
	}
	 
	
	.left-container {
	
	background-color: #F38181;
	
	height: 100%;
	
	}
	 
	
	.right-container {
	
	background-color: #FCE38A;
	
	height: 200px;
	
	}
	 
	.row-bg {
	    padding: 0px 0;
	    /* background-color: #f9fafc; */
	  }
	.top-container {
	
	background-color: #FCE38A;
	
	width: 100%;
	
	height: 100%;
	
	}
	 
	
	.bottom-container {
	
	width: 100%;
	
	background-color: #95E1D3;
	
	height: 100%;
	
	}
	 
	
	.left-container-twoOne {
	
	background-color: rgb(110, 75, 75);
	
	height: 100%;
	
	}
	 
	
	.container-onetoOne {
	
	background-color: rgb(47, 80, 74);
	
	height: 100%;
	
	width: 50%;
	
	}
	 
	
	.container-onetoTwo {
	
	background-color: rgb(61, 19, 56);
	
	height: 100%;
	
	width: 50%;
	
	}
	 
	
	.el-col {
	
	border-radius: 4px;
	
	}
	
	.bg-purple-dark {
	
	background: #57926b;
	
	}
	
	.bg-purple {
	
	background: #7e2970;
	
	}
	
	.bg-purple-light {
	
	background: #071c4d;
	
	}
	
	.grid-content {
	
	background-color: rgb(44, 143, 121);
	
	border-radius: 4px;
	
	min-height: 150px;
	
	min-width: 100px;
	
	}
	
	
	
	.grid-a-contentWidth {
	
	background-color: rgb(44, 143, 121);
	
	
	
	min-height: 100px;
	margin-top: 10px;
	text-align: center;
	outline-width: 1px;
	outline-offset: inherit;
	outline-color: red;
	}
	
	.grid-a-content-a-Width {
	
	background-color: rgb(44, 143, 121);
	
	border-radius: 4px;
	
	min-height: 220px;
	
	}
	 
	
	.grid-one-contentheight {
	
	background-color: rgb(44, 143, 121);
	
	border-radius: 4px;
	
	min-height: 100%;
	
	}
	 
	
	.el-row-two {
	
	margin-bottom: 80px;
	
	margin-top: 80px;
	 
	
	}
	.pCardRl{
		height: 150px;
		margin-right: 4px;
		margin-bottom: 4px;
		outline: #0098DB;
		outline-style: double;
		outline-width: 0.01px;
	}
	.divValue{
		text-align: center;
		margin-top: 25px;
	}
	.divStatus{
		text-align: center;
		margin-top: 25px;
	}
</style>
